document.addEventListener("DOMContentLoaded", () => {
  const builders = document.querySelectorAll(".yes-box-builder");

  builders.forEach((builder) => {
    const maxItems = Number(builder.dataset.maxItems || 3);
    const parentVariantId = builder.dataset.parentVariantId;
    const cartUrl = builder.dataset.cartUrl || "/cart";

    const journey = builder.querySelector(".yes-box-builder__journey");
    const productCards = [...builder.querySelectorAll("[data-product-card]")];
    const slots = [...builder.querySelectorAll("[data-slot-index]")];
    const countElements = [...builder.querySelectorAll("[data-selected-count]")];
    const messageElements = [...builder.querySelectorAll("[data-selection-message]")];
    const bottomStatus = builder.querySelector("[data-bottom-status]");
    const addBundleButton = builder.querySelector("[data-add-bundle]");

    const selectedProducts = [];

    let journeyPlaceholder;
    let scrollFrame;

    function getStoreHeader() {
      const headerSelectors = [
        "#shopify-section-header",
        "sticky-header",
        ".header-wrapper",
        "header"
      ];

      return headerSelectors
        .map((selector) => document.querySelector(selector))
        .find((header) => header && header.offsetHeight > 0);
    }

    function updateHeaderOffset() {
      const storeHeader = getStoreHeader();

      const headerHeight = storeHeader
        ? Math.ceil(
            storeHeader.getBoundingClientRect().height ||
            storeHeader.offsetHeight
          )
        : 76;

      const offset = headerHeight + 8;

      builder.style.setProperty(
        "--yes-box-header-offset",
        `${offset}px`
      );

      return offset;
    }

    function getJourneyPlaceholder() {
      if (journeyPlaceholder) {
        return journeyPlaceholder;
      }

      journeyPlaceholder = document.createElement("div");
      journeyPlaceholder.className = "yes-box-builder__journey-placeholder";

      journey.parentNode.insertBefore(journeyPlaceholder, journey);

      return journeyPlaceholder;
    }

    function pinJourney() {
      if (!journey || journey.classList.contains("is-pinned")) {
        return;
      }

      const placeholder = getJourneyPlaceholder();

      placeholder.style.display = "block";
      placeholder.style.height = `${Math.ceil(journey.offsetHeight)}px`;

      journey.classList.add("is-pinned");
    }

    function unpinJourney() {
      if (!journey || !journey.classList.contains("is-pinned")) {
        return;
      }

      journey.classList.remove("is-pinned");

      if (journeyPlaceholder) {
        journeyPlaceholder.style.display = "none";
        journeyPlaceholder.style.height = "0";
      }
    }

    function updateJourneyPosition() {
      if (!journey) {
        return;
      }

      const headerOffset = updateHeaderOffset();

      const referenceElement = journey.classList.contains("is-pinned")
        ? getJourneyPlaceholder()
        : journey;

      const referenceRect = referenceElement.getBoundingClientRect();
      const builderRect = builder.getBoundingClientRect();
      const journeyHeight = journey.getBoundingClientRect().height;

      const canRemainPinned =
        builderRect.bottom > headerOffset + journeyHeight + 24;

      if (referenceRect.top <= headerOffset && canRemainPinned) {
        pinJourney();
      } else {
        unpinJourney();
      }
    }

    function scheduleJourneyUpdate() {
      if (scrollFrame) {
        return;
      }

      scrollFrame = window.requestAnimationFrame(() => {
        updateJourneyPosition();
        scrollFrame = null;
      });
    }

    updateJourneyPosition();

    window.addEventListener("scroll", scheduleJourneyUpdate, {
      passive: true
    });

    window.addEventListener("resize", scheduleJourneyUpdate);
    window.addEventListener("load", scheduleJourneyUpdate);

    const storeHeader = getStoreHeader();

    if (storeHeader && "ResizeObserver" in window) {
      const headerResizeObserver = new ResizeObserver(() => {
        scheduleJourneyUpdate();
      });

      headerResizeObserver.observe(storeHeader);
    }

    function getProductFromCard(card) {
      return {
        variantId: card.dataset.variantId,
        title: card.dataset.productTitle,
        image: card.dataset.productImage
      };
    }

    function removeProduct(variantId) {
      const index = selectedProducts.findIndex(
        (product) => product.variantId === variantId
      );

      if (index > -1) {
        selectedProducts.splice(index, 1);
        renderBuilder();
      }
    }

    function selectionMessage(count) {
      if (count === 0) {
        return "Add 3 skincare essentials to build your box.";
      }

      if (count === 1) {
        return "Great choice — add 2 more products.";
      }

      if (count === 2) {
        return "Almost there — add 1 more product.";
      }

      return "Your Everyday Box is ready.";
    }

    function selectionButtonText(count) {
      if (count === 0) return "Select 3 Products";
      if (count === 1) return "Add 2 More Products";
      if (count === 2) return "Add 1 More Product";
      return "Add Bundle to Cart";
    }

    function renderSlots() {
      slots.forEach((slot, index) => {
        const selected = selectedProducts[index];

        slot.innerHTML = "";
        slot.classList.remove("is-filled");

        if (!selected) {
          const number = document.createElement("span");
          number.className = "yes-box-slot__number";
          number.textContent = String(index + 1);
          slot.appendChild(number);
          return;
        }

        slot.classList.add("is-filled");

        if (selected.image) {
          const image = document.createElement("img");
          image.className = "yes-box-slot__image";
          image.src = selected.image;
          image.alt = selected.title;
          slot.appendChild(image);
        }

        const removeButton = document.createElement("button");
        removeButton.type = "button";
        removeButton.className = "yes-box-slot__remove";
        removeButton.setAttribute(
          "aria-label",
          `Remove ${selected.title} from your box`
        );
        removeButton.textContent = "×";

        removeButton.addEventListener("click", () => {
          removeProduct(selected.variantId);
        });

        slot.appendChild(removeButton);
      });
    }

    function renderCards() {
      const selectionIsFull = selectedProducts.length >= maxItems;

      productCards.forEach((card) => {
        const button = card.querySelector("[data-add-product]");
        const variantId = card.dataset.variantId;

        const isSelected = selectedProducts.some(
          (product) => product.variantId === variantId
        );

        const isAvailable = card.dataset.available === "true";

        card.classList.toggle("is-selected", isSelected);

        if (isSelected) {
          button.textContent = "Remove";
          button.disabled = false;
          button.setAttribute("aria-pressed", "true");
          return;
        }

        button.textContent = "Add to Box";
        button.setAttribute("aria-pressed", "false");
        button.disabled = !isAvailable || selectionIsFull;
      });
    }

    function renderSummary() {
      const count = selectedProducts.length;
      const message = selectionMessage(count);

      countElements.forEach((element) => {
        element.textContent = count;
      });

      messageElements.forEach((element) => {
        element.textContent = message;
      });

      if (bottomStatus) {
        bottomStatus.textContent = `${count} / ${maxItems} selected`;
      }

      addBundleButton.textContent = selectionButtonText(count);
      addBundleButton.disabled = count !== maxItems;
    }

    function renderBuilder() {
      renderSlots();
      renderCards();
      renderSummary();
      scheduleJourneyUpdate();
    }

    productCards.forEach((card) => {
      const button = card.querySelector("[data-add-product]");

      button.addEventListener("click", () => {
        const product = getProductFromCard(card);

        const existingIndex = selectedProducts.findIndex(
          (selected) => selected.variantId === product.variantId
        );

        if (existingIndex > -1) {
          selectedProducts.splice(existingIndex, 1);
          renderBuilder();
          return;
        }

        if (selectedProducts.length >= maxItems) {
          return;
        }

        selectedProducts.push(product);
        renderBuilder();
      });
    });

    addBundleButton.addEventListener("click", async () => {
      if (selectedProducts.length !== maxItems || !parentVariantId) {
        return;
      }

      addBundleButton.disabled = true;
      addBundleButton.textContent = "Adding your box...";

      const chosenTitles = selectedProducts
        .map((product, index) => `${index + 1}. ${product.title}`)
        .join(" | ");

      try {
        const root =
          window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : "/";

        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(parentVariantId),
                quantity: 1,
                properties: {
                  "Your selected products": chosenTitles,
                  "_yes_bundle_variant_ids": selectedProducts
                    .map((product) => product.variantId)
                    .join(","),
                  "_yes_bundle_offer": "Pick Any 3 @ ₹1499"
                }
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error("Cart request failed");
        }

        window.location.href = cartUrl;
      } catch (error) {
        console.error(error);
        addBundleButton.disabled = false;
        addBundleButton.textContent = "Try Again";
        alert("Your box could not be added. Please try again.");
      }
    });

    renderBuilder();
  });
});